module.exports = __webpack_public_path__ + "img/file1.67f9467d.png";